var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"echartsRef",style:({ 
        'width': 'auto',
        'height': _vm.echartsObj.height? _vm.echartsObj.height : 'calc(100vh - 630px)',
        'margin-top': '34px',
        'min-height': '258px',
    })})
}
var staticRenderFns = []

export { render, staticRenderFns }